import {Button} from "@root/server/client/esweb/components/ui/button.tsx";
import {ChevronRight} from "lucide-react";
import React from "react";


export const ContinueSubmitButton = (params: {isSubmitting?: boolean, canSubmit?: boolean}) => {
    const {
        isSubmitting,
        canSubmit = true
    } = params;

    return <Button type="submit" size="lg" className="w-full" disabled={isSubmitting || !canSubmit}>
        {isSubmitting ? "Ukládám..." : "Pokračovat"}
        <ChevronRight/>
    </Button>
}